import React from 'react';
import { Box } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

import { customSizes, spaces } from '../../assets/styles/themes/tokens';
import EmptySearchStateImage from '../Search/SearchResults/EmptySearchResultsNewUI/EmptySearchStateImage';
import { Link } from 'found';
import { routes } from '../../constants';

const OwnCollectionOverviewEmptyState = () => {
  const { t } = useTranslation();

  return (
    <Box data-testid='own-collection-overview-empty-state' sx={{ padding: spaces.xl }}>
      <EmptySearchStateImage
        title={t('It is currently still quite empty here')}
        subtitle={
          <Trans
            i18nKey='Start searching for the right content for this collection!'
            key={1}
          >
            <Link to={`/${routes.search.root}`}></Link>
          </Trans>
        }
        subtitleSx={{ maxWidth: customSizes.emptyStateSubtitleMaxWidth, textAlign: 'center' }}
        containerSx={{ paddingBottom: 0 }}
        iconName='emptyState'
      />
    </Box>
  );
};

export default OwnCollectionOverviewEmptyState;
